import { EnvironmentConfig } from '@ipreo/northstar';

export enum Platform {
  buyside = 'buyside',
  polaris = 'polaris'
}

export const isBuyside = (config: EnvironmentConfig): boolean =>
  config.params && config.params['platform'] === Platform.buyside;

export const isPolaris = (config: EnvironmentConfig): boolean =>
  config.params && config.params['platform'] === Platform.polaris;
